export type PaginatedPage<T> = {
  number: number
  items: T[]
  isFirst: boolean
  isLast: boolean
}

export function paginate<T>(array: T[], size: number): Array<PaginatedPage<T>> {
  if (size <= 0) {
    throw new Error('Chunk size must be positive')
  }

  const pages: Array<PaginatedPage<T>> = []

  if (array.length == 0) {
    return [{ number: 1, items: [], isFirst: true, isLast: true }]
  }

  for (let i = 0; i < array.length; i += size) {
    pages.push({
      number: i + 1,
      isFirst: false,
      isLast: false,
      items: array.slice(i, i + size)
    })
  }

  pages[0].isFirst = true
  pages[pages.length - 1].isLast = true

  return pages
}
